<template>
  <div class="home">
    <header-c></header-c>
    <el-carousel indicator-position="outside" height="550px" class="carouselClass">
      <el-carousel-item v-for="item in showPic" :key="item.id">
        <img class="showPicImg" :src="item.url" alt />
      </el-carousel-item>
    </el-carousel>
    <div class="home-content">
      <div class="home-content-top">
        <h2>精选全景</h2>
        <span>优质的全景作品赏析</span>
      </div>
      <div class="home-content-pics" v-if="showGoodPics.length > 0">
        <div class="pics-left">
          <div class="pics-left-div">
            <img v-if="showGoodPics[0]" :src="showGoodPics[0].url" alt class="pics1" />
            <div class="content" v-if="showGoodPics[0]">{{ showGoodPics[0].name }}</div>
          </div>
        </div>
        <div class="pics-right">
          <div class="flexRow">
            <div class="flexRow-left1">
              <img v-if="showGoodPics[1]" class="pics2" :src="showGoodPics[1].url" alt />
              <div class="content" v-if="showGoodPics[1]">{{ showGoodPics[1].name }}</div>
            </div>
            <div class="flexRow-right1">
              <img v-if="showGoodPics[2]" class="pics2" :src="showGoodPics[2].url" alt />
              <div class="content" v-if="showGoodPics[2]">{{ showGoodPics[2].name }}</div>
            </div>
          </div>
          <div class="flexRow">
            <div class="flexRow-left2">
              <img v-if="showGoodPics[3]" class="pics2" :src="showGoodPics[3].url" alt />
              <div class="content" v-if="showGoodPics[3]">{{ showGoodPics[3].name }}</div>
            </div>
            <div class="flexRow-right2">
              <img v-if="showGoodPics[4]" class="pics2" :src="showGoodPics[4].url" alt />
              <div class="content" v-if="showGoodPics[4]">{{ showGoodPics[4].name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-c></footer-c>
  </div>
</template>

<script>
import HeaderC from "@/components/header/index.vue";
import FooterC from "@/components/footer/index.vue";

export default {
  name: "HomeView",
  components: {
    HeaderC,
    FooterC
  },
  mounted() {
    document.title = '云博展主页 - 云展'; 
    this.showGoodPics = [
      {
        id: 1,
        name: "府学文庙",
        url: "http://yun-bo-zhan-vr.oss-cn-hangzhou.aliyuncs.com/2/panos/18ed799633c4b5ce/thumb.jpg?x-oss-process=image/resize,m_fill,h_320,w_480",
      },
      {
        id: 2,
        name: "街头孝道文化展示馆",
        url: "https://yun-bo-zhan-vr.oss-cn-hangzhou.aliyuncs.com/2/panos/4f2dd166c1891587/thumb.jpg?x-oss-process=image/resize,m_fill,h_320,w_330",
      },
      {
        id: 3,
        name: "温州科举馆",
        url: "https://yun-bo-zhan-vr.oss-cn-hangzhou.aliyuncs.com/2/panos/7bc7bbb6e2c96043/thumb.jpg?x-oss-process=image/resize,m_fill,h_320,w_330",
      },
      {
        id: 4,
        name: "眼视光院史馆",
        url: "https://yun-bo-zhan-vr.oss-cn-hangzhou.aliyuncs.com/2/panos/34e50fe66fa49316/thumb.jpg?x-oss-process=image/resize,m_fill,h_380,w_480",
      },
      {
        id: 5,
        name: "眼视光科普馆",
        url: "https://yun-bo-zhan-vr.oss-cn-hangzhou.aliyuncs.com/2/panos/9c0c8895741a9389/thumb.jpg?x-oss-process=image/resize,m_fill,h_600,w_600",
      },
    ];
  },
  data() {
    return {
      showPic: [
        // 将数据移到 data 函数中
        { id: 1, name: "沙盘1", url: require("@/assets/hangpai.jpg") },
        // { id: 2, name: "场景1", url: require("@/assets/测试.jpg") },
      ],
      showGoodPics: [],
    };
  },
  methods: {
    logTest() {
      console.log("test");
    },
  },
};
</script>

<style scoped>
  .flexRow{
    display: flex;
    flex-direction: row;
    /* gap: 10px; */

  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .showPicImg{
    width: 100%;
    height: 100%;
    object-fit:fill
  }
  
  .home-content,.carouselClass{
    padding: 0 15px;
    margin: 0 auto;
    max-width: 1500px;
  }
  .home-content-top{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  h2{
    font-size: 20px;
    color: #333;
  }
  span{
    font-size: 14px;
    color: #999;
    margin-left: 15px;
  }
  .home-content-pics{
    height: 450px;
    display: flex;
    flex-direction: row;
  }
  .pics-left{
    flex: 3;
  }
  .pics-right{
    flex: 7;
  }
  .pics-left-div{
    height: 100%; 
    position: relative;
  }
  .pics1{
    width: 100%;
    height: 100%;

  }
  .pics2{
    width: 100%;  /* 宽度根据父容器自适应 */
  height: 100%;  /* 高度根据父容器自适应 */
  object-fit: fill;  /* 保持图片比例适应容器 */
  }
  .flexRow-left1{
    flex: 3;
    height: 225px;
    position: relative;
  }
  .flexRow-right1{
    flex: 7;
    height: 225px;
    position: relative;

  }
  .flexRow-left2{
    position: relative;
    flex: 7;
    height: 225px;

  }
  .flexRow-right2{
    position: relative;
    flex: 3;
    height: 225px;
  }
  .content{
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: auto;
    background-color: rgba(0,0,0,.5);
    padding: 8px 20px;
    font-size: 14px;
    color: #fff;
  }
</style>
